
/**
 * Get direction (['rtl', 'ltr', 'auto']) from html attribute in the DOM.
 */
function getDir() {
    const dirValue = document.getElementsByTagName("html")[0].getAttribute("dir");
    return dirValue || 'auto';
}

/**
 *
 * DirUtil
 *
 * @namespace DirUtil
 */
export default {
    getDir : getDir
};
